import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initPixel, trackPixelPageView } from '../utils/metaPixel';

export default function MetaPixel({ consentGranted }) {
  const location = useLocation();
  const pixelId = process.env.REACT_APP_META_PIXEL_ID;

  useEffect(() => {
    if (consentGranted && pixelId && !window.fbq) {
      initPixel(pixelId);
    }
  }, [consentGranted, pixelId]);

  useEffect(() => {
    if (consentGranted && pixelId && window.fbq) {
      trackPixelPageView();
    }
  }, [location, consentGranted, pixelId]);

  return null;
}
